import { TaxDeductionCard } from '@/features/user/dashboard/insights-cards/TaxDeductionCard'
import { TaxDeductionTipCard } from '@/features/user/dashboard/insights-cards/TaxDeductionTipCard'
import { Text, Card, CardColors } from '@/ui'
import { TypographyStyles } from '@/styles'

export const MaximizeTaxDeductionsCard = () => {
  return (
    <Card color={CardColors.LEVEL_0}>
      <Text variant={TypographyStyles.H1} className="w-full header-text">
        Maximize Tax Deductions
      </Text>

      <div className="flex flex-col lg:flex-row gap-6">
        <div className="lg:w-2/3 w-full">
          <TaxDeductionCard />
        </div>
        <div className="lg:w-1/3 w-full">
          <TaxDeductionTipCard />
        </div>
      </div>
    </Card>
  )
}
